<div class="ops-container">
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>
